export const BROWSE_KEY = '__BROWSE__';

export interface SearchUnitNode {
	id: string;
	name: string;
	subtitle: string | null;
	path: string;
}
